
import { Component, Vue, Ref } from 'vue-property-decorator'
import { UserService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'behavior-path',
    components: {
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private tableData = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private sort = 'new'
    private loading = false
    private fetchLoading = true

    private mounted() {
        this.getAccessStat({ reset: true })
    }

    private async getAccessStat(option = { reset: false }) {
        if (!option.reset) this.loading = true
        const params = { 
            user_id: this.$route.params.id,
            sort: this.sort,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await UserService.getAccessStat(params)
        if (this.loading) this.loading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.tableData = result.data.list
            if (this.fetchLoading) this.fetchLoading = false
        }
    }

    private onSortChange() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.getAccessStat()
    }

    private onCurrentChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getAccessStat)
    }
}
